(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8251],{

/***/ 92776:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[id]/parks",
      function () {
        return __webpack_require__(70753);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ UserPublicProfile; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./modules/UserProfile/hooks.ts
var hooks = __webpack_require__(26136);
// EXTERNAL MODULE: ../ui/src/components/Loading/Loading.tsx
var Loading = __webpack_require__(69193);
// EXTERNAL MODULE: ./modules/UserProfile/Wrappers/UserPageWrapper.tsx
var UserPageWrapper = __webpack_require__(4976);
// EXTERNAL MODULE: ./modules/UserProfile/Wrappers/UserPageContentWrapper.tsx
var UserPageContentWrapper = __webpack_require__(62649);
// EXTERNAL MODULE: ./modules/UserProfile/Wrappers/UserSubpageWrapper.tsx
var UserSubpageWrapper = __webpack_require__(93540);
// EXTERNAL MODULE: ./modules/UserProfile/ProfileCover/ProfileCover.tsx
var ProfileCover = __webpack_require__(7247);
// EXTERNAL MODULE: ./modules/User/SubscribeButton/SubscribeButton.tsx + 1 modules
var SubscribeButton = __webpack_require__(48102);
// EXTERNAL MODULE: ./modules/UserProfile/ProfileAvatar/ProfileAvatar.tsx
var ProfileAvatar = __webpack_require__(11676);
// EXTERNAL MODULE: ./modules/UserProfile/UserInfo/ActionsRow.tsx
var ActionsRow = __webpack_require__(59070);
// EXTERNAL MODULE: ./modules/UserProfile/UserInfo/UserInfoContent.tsx + 2 modules
var UserInfoContent = __webpack_require__(21882);
// EXTERNAL MODULE: ../ui/src/components/Button/Button.tsx
var Button = __webpack_require__(57100);
// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(83849);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./modules/UserProfile/UserInfo/UserPublicInfo.tsx








const UserPublicInfo = (param)=>{
    let { user  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "relative p-4 bg-white rounded-2xl w-full max-w-[1126px] mx-auto mb-10 md:mb-7 md:flex md:items-center md:gap-6 md:px-6 md:py-8 lg:gap-10 lg:mb-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-1/2 -translate-x-1/2 -top-[85px] w-fit md:static md:translate-x-0 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatar/* ProfileAvatar */.S, {
                    src: user.avatar_key
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " w-full grid mt-[80px] md:mt-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto md:absolute md:top-6 md:right-6 lg:top-8 lg:right-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionsRow/* ActionsRow */.G, {
                            user: user
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfoContent/* UserInfoContent */.V, {
                        user: user,
                        subscribeButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeButton/* SubscribeButton */.T, {
                            button: (param)=>/*#__PURE__*/ {
                                let { subscribe , isSubscribed , isLoading  } = param;
                                return (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                    disabled: isLoading,
                                    variant: isSubscribed ? "base" : "outline",
                                    onClick: ()=>subscribe(user.cognito_id),
                                    className: classnames_default()({
                                        "bg-neutral-100": isSubscribed
                                    }, "!drop-shadow h-[40px] flex items-center !px-4 text-[14px]"),
                                    children: isSubscribed ? "Subscribed" : "Subscribe"
                                });
                            },
                            isSubscribed: user.isSubscribed,
                            accountId: user.cognito_id,
                            className: "!drop-shadow h-[40px] flex items-center !px-4 text-[14px]"
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./modules/UserProfile/MainTabs/MainTabs.tsx
var MainTabs = __webpack_require__(9382);
// EXTERNAL MODULE: ./modules/Video/VideoModalContext.tsx
var VideoModalContext = __webpack_require__(35715);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-seo@5.8.0_aqiqc4vv7pffmc2pmelp4wqb4e/node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(98334);
// EXTERNAL MODULE: ./utils/useResolveAwsImgPath.ts
var useResolveAwsImgPath = __webpack_require__(32554);
// EXTERNAL MODULE: ./modules/Config/ConfigContext.tsx
var ConfigContext = __webpack_require__(65729);
;// CONCATENATED MODULE: ./modules/UserProfile/UserPublicProfileSeo.tsx





const UserPublicProfileSeo = (param)=>{
    let { user  } = param;
    const { pageUrl  } = (0,ConfigContext/* useConfig */.ZR)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
        title: user.name,
        defaultTitle: user.name,
        titleTemplate: user.name,
        description: user.description || undefined,
        openGraph: {
            url: "".concat(pageUrl, "/users/").concat(user.cognito_id),
            ...user.avatar_url ? {
                images: [
                    {
                        url: (0,useResolveAwsImgPath/* useResolveAwsImgPath */.u)(user.avatar_url),
                        width: 601,
                        height: 601,
                        secureUrl: (0,useResolveAwsImgPath/* useResolveAwsImgPath */.u)(user.avatar_url),
                        alt: user.name
                    }
                ]
            } : undefined
        }
    });
};

// EXTERNAL MODULE: ./utils/useButtonsAnalytics.tsx
var useButtonsAnalytics = __webpack_require__(76356);
;// CONCATENATED MODULE: ./modules/UserProfile/UserPublicProfile.tsx











const UserPublicProfile = (param)=>{
    let { children , id  } = param;
    (0,useButtonsAnalytics/* useButtonsAnalytics */.V)();
    const { useUserProfileQuery , useUserResourceCountQuery  } = (0,hooks/* useUserProfile */.Gr)();
    const { data: userProfile , isLoading  } = useUserProfileQuery(id);
    const { data: resourceCount  } = useUserResourceCountQuery(id);
    if (!userProfile || isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoModalContext/* VideoModalProvider */.ke, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserPublicProfileSeo, {
                user: userProfile
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserPageWrapper/* UserPageWrapper */.d, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileCover/* ProfileCover */.D, {
                        src: userProfile.background_key
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserPageContentWrapper/* UserPageContentWrapper */.L, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserPublicInfo, {
                                user: userProfile
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserSubpageWrapper/* UserSubpageWrapper */.X, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MainTabs/* MainTabs */.E, {
                                        links: [
                                            {
                                                href: "/users/".concat(id, "/#nav-scroll"),
                                                match: "/users/[id]",
                                                text: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainTabs/* LinkCounter */._, {
                                                    name: "My Videos",
                                                    counter: resourceCount && resourceCount.videosCount
                                                })
                                            },
                                            {
                                                href: "/users/".concat(id, "/parks/#nav-scroll"),
                                                match: "/users/[id]/parks",
                                                text: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainTabs/* LinkCounter */._, {
                                                    name: "My Parks",
                                                    counter: resourceCount && "".concat(resourceCount.unlockedStickersCount, "/").concat(resourceCount.parksWithStickersCount)
                                                })
                                            }
                                        ]
                                    }),
                                    typeof children === "function" ? children(userProfile) : children
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 70753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ parks; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./modules/UserProfile/UserPublicProfile.tsx + 2 modules
var UserPublicProfile = __webpack_require__(80960);
// EXTERNAL MODULE: ./modules/UserProfile/hooks.ts
var hooks = __webpack_require__(26136);
// EXTERNAL MODULE: ./modules/UserProfile/UserStickerList/UserStickerList.tsx + 4 modules
var UserStickerList = __webpack_require__(19274);
// EXTERNAL MODULE: ../ui/src/components/Loading/Loading.tsx
var Loading = __webpack_require__(69193);
;// CONCATENATED MODULE: ./modules/Pages/UserPublicProfilePage/UserPublicProfileParksPage.tsx





const UserPublicProfileParksPage = (param)=>{
    let { query: { id  }  } = param;
    const { useUserStickersInfiniteQuery  } = (0,hooks/* useUserVideos */.Dp)();
    const { data: stickers , isLoading , fetchNextPage , isFetchingNextPage , hasNextPage  } = useUserStickersInfiniteQuery(id, {
        page: 1,
        limit: 30,
        search: null
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserPublicProfile/* UserPublicProfile */.A, {
        id: id,
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {}) : stickers ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UserStickerList/* UserStickerListWithInfinityScroll */.x, {
            data: stickers,
            fetchNextPage: fetchNextPage,
            hasNextPage: hasNextPage,
            isFetchingNextPage: isFetchingNextPage
        }) : null
    });
};

;// CONCATENATED MODULE: ./pages/users/[id]/parks.tsx

var __N_SSP = true;
/* harmony default export */ var parks = (UserPublicProfileParksPage);


/***/ }),

/***/ 32554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useResolveAwsImgPath; }
/* harmony export */ });
/* harmony import */ var _modules_Config_ConfigContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65729);

const useResolveAwsImgPath = (src)=>{
    const { pageUrl  } = (0,_modules_Config_ConfigContext__WEBPACK_IMPORTED_MODULE_0__/* .useConfig */ .ZR)();
    return "".concat(pageUrl).concat(src);
};


/***/ }),

/***/ 2783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const Skeleton = (param)=>{
    let { variant ="rounded" , width ="100%" , height ="auto" , animation =false , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            width,
            height
        },
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("bg-neutral-100 relative overflow-hidden my-2", variantStyles(variant), skeletonAnimation(animation), className)
    });
};
function variantStyles(variant) {
    switch(variant){
        case "circular":
            return "rounded-full";
        case "rounded":
            return "rounded";
        case "rectangular":
            return "rounded-none";
    }
}
function skeletonAnimation(animation) {
    switch(animation){
        case "animate-pulse":
            return "animate-pulse";
        case "animate-shimmer":
            return "after:absolute after:top-0 after:bottom-0 after:left-0 after:right-0 after:bg-gradient-to-r after:from-transparent after:via-neutral-400/10 after:to-transparent after:-translate-x-full after:animate-shimmerMove";
        case false:
            return "";
        default:
            return animation;
    }
}


/***/ }),

/***/ 30326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 42875:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 37342:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@babel+runtime@7.18.9/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 58205:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6774,7004,2411,3740,9274,9774,2888,179], function() { return __webpack_exec__(92776); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);